export const links = [
    { 
        name: 'ACADEMIE', 
        href: '/academie',
        image: '/home-categories/AcademieParis3-157x157.jpg'
    },
    { 
        name: 'BTpeeL', 
        href: '/btpeel',
        image: '/home-categories/btpeel_foto_3-157x157.jpg'
    },
    { 
        name: 'Уход за лицом', 
        href: '/face',
        image: '/home-categories/f2-157x157.jpg'
    },
    { 
        name: 'Химические пилинги', 
        href: '/ximicheskie-pilingi1',
        image: '/home-categories/him-pilingi-20-157x157.jpg'
    },
    { 
        name: 'Защита от солнца', 
        href: '/sun',
        image: '/home-categories/157sun-157x157.jpg'
    },
    { 
        name: 'Аппараты', 
        href: '/apparatnaja-kosmetologija',
        image: '/home-categories/US-157x157.jpg'
    },
    { 
        name: 'Уход за телом', 
        href: '/body',
        image: '/home-categories/b2-157x157.jpg'
    },
    { 
        name: 'Уход за волосами', 
        href: '/keratinovoe-vyprjamlenie-volos-ultra-btpeel',
        image: '/home-categories/2e10bcc05fa518fb8b07ce67f5f17447-157x157.jpg'
    },
]